/**
 * ReDelivery v1
 * El delivery mas coopado
 *
 * OpenAPI spec version: v1
 * Contact: redjar.redelivery@gmail.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type EnumsPaymentMethod = 0 | 1;

export const EnumsPaymentMethod = {
    NUMBER_0: 0 as EnumsPaymentMethod,
    NUMBER_1: 1 as EnumsPaymentMethod
};